// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-datenschutz-js": function componentSrcPagesDatenschutzJs() {
    return import("./../../src/pages/datenschutz.js"
    /* webpackChunkName: "component---src-pages-datenschutz-js" */
    );
  },
  "component---src-pages-impressum-js": function componentSrcPagesImpressumJs() {
    return import("./../../src/pages/impressum.js"
    /* webpackChunkName: "component---src-pages-impressum-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-kontakt-js": function componentSrcPagesKontaktJs() {
    return import("./../../src/pages/kontakt.js"
    /* webpackChunkName: "component---src-pages-kontakt-js" */
    );
  },
  "component---src-pages-projekte-js": function componentSrcPagesProjekteJs() {
    return import("./../../src/pages/projekte.js"
    /* webpackChunkName: "component---src-pages-projekte-js" */
    );
  },
  "component---src-templates-project-template-js": function componentSrcTemplatesProjectTemplateJs() {
    return import("./../../src/templates/projectTemplate.js"
    /* webpackChunkName: "component---src-templates-project-template-js" */
    );
  }
};